import { defineMessages } from "react-intl";

import {
	immunizationMessages,
	validator
} from "lib/build/forms/ltx/phase-i/vaccinationStatus";

import {
	FieldData,
	FieldGroupListData,
	FieldsetData
} from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	vaccinationStatus: {
		id: "form.ltx_vaccination_status",
		defaultMessage: "Védőoltások"
	},
	vaccineType: {
		id: "form.ltx_vaccination_status.vaccine_type",
		defaultMessage: "Oltás típusa"
	},
	immunization: {
		id: "form.ltx_vaccination_status.immunization",
		defaultMessage: "Immunizáció"
	},
	vaccineName: {
		id: "form.ltx_vaccination_status.vaccine_name",
		defaultMessage: "Oltóanyag neve"
	},
	numberOfDoses: {
		id: "form.ltx_vaccination_status.number_of_doses",
		defaultMessage: "Oltások száma"
	},
	dateOfLastDose: {
		id: "form.ltx_vaccination_status.date_of_last_dose",
		defaultMessage: "Utolsó oltás dátuma"
	}
});

const fields: { [key: string]: FieldGroupListData | FieldData } = {
	vaccineType: {
		type: "field-group-list",
		path: ["vaccineType"],
		label: messages.vaccineType,
		rows: [
			{
				columns: [
					{
						width: 6,
						field: {
							type: "field",
							path: ["immunization"],
							label: messages.immunization,
							errorMessages: genericErrorMessages,
							input: {
								type: "select",
								props: { labels: immunizationMessages }
							}
						}
					},
					{
						width: 6,
						field: {
							type: "field",
							path: ["vaccineName"],
							label: messages.vaccineName,
							errorMessages: genericErrorMessages,
							input: { type: "input", props: { type: "text" } }
						}
					}
				]
			},
			{
				columns: [
					{
						width: 6,
						field: {
							type: "field",
							path: ["numberOfDoses"],
							label: messages.numberOfDoses,
							errorMessages: genericErrorMessages,
							input: { type: "input", props: { type: "number" } }
						}
					},
					{
						width: 6,
						field: {
							type: "field",
							path: ["dateOfLastDose"],
							label: messages.dateOfLastDose,
							errorMessages: genericErrorMessages,
							input: { type: "input", props: { type: "date" } }
						}
					}
				]
			}
		]
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.vaccineType }] }]
};

export const node: LeafNode = {
	id: "vaccinationStatus",
	value: {
		title: messages.vaccinationStatus,
		validator,
		fieldset
	}
};
